import React, { useState, useEffect, useMemo } from "react";
import { BiPlus } from "react-icons/bi";
import CustomButton from "components/common/Button/CustomButton";
import SelectOption from "components/common/Select/Select";
import SideBar from "components/common/SideBar/SideBarNew";
import TableHeader from "components/common/Table/TableHeader";
import { LOADER_STATUS } from "Constants/constant";
import { LoginContext } from "helpers/LoginContext";
import CheckBox from "components/common/checkBox/checkbox";
import COSInvoiceTabel from "./COSInvoiceTabel";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import DateRangePickerNew from "components/common/DateRangePicker/DateRangePickerNew";
import Header from "components/common/Header/Header";
import Breadcrumb from "components/common/Breadcrumb";
import {
  AH_BREADCRUMB,
  AH_BREADCRUMB_PAGES,
} from "Constants/BreadcrumbConstant";
import COSNewModal from "./COSNewModal";
import useCareLabels from "hooks/useCareLabels";

const COSInvoicePage = (props) => {
  const {
    cosInvoiceList,
    cosInvoiceLoading,
    createCosInvoiceLoading,
    createCosInvoices,
    getCosInvoice,
    emptyTableData,
    getClientsRequest,
    clientsList,
    supportCoordinatorsRequest,
    supportCoordinator,
    clientsListLoader,
    cosInvoiceMode,
    getCosInvoiceMode,
  } = props;

  const { sideBarPadding, isUserGracePeriodOver } =
    React.useContext(LoginContext);
  const { participantLabel } = useCareLabels();
  const [renderLoading, setRenderLoading] = useState(LOADER_STATUS.NA);
  const [checkboxes, setCheckboxes] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [supportCoordiantion, setSupportCoordination] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [deliveredFromDate, setDeliveredFromDate] = useState(null);
  const [deliveredToDate, setDeliveredToDate] = useState(null);
  const [amount, setAmount] = useState(0);
  const [quantity, setQuantity] = useState(0);
  const [isOpenModel, setIsModelOpen] = useState(false);
  const [reportType, setReportType] = useState(null);

  const cosInvoiceListToMap = useMemo(() => {
    if (cosInvoiceList && cosInvoiceList.length > 0) {
      return cosInvoiceList;
    }
    return [];
  }, [cosInvoiceList]);

  const isNewMode = (cosInvoiceMode || "old") === "new";

  const handleCheckboxChange = (e, id, item) => {
    const filteredList = checkboxes.filter((c) => c !== id);
    if (e) {
      filteredList.push(id);
      setAmount(() => parseFloat(amount) + parseFloat(item.total_amount));
      setQuantity(() => parseInt(quantity) + parseInt(item.quantity));
    } else {
      setAmount(() => parseFloat(amount) - parseFloat(item.total_amount));
      setQuantity(() => parseInt(quantity) - parseInt(item.quantity));
    }
    setCheckboxes(filteredList);
  };

  const toggleCheckboxes = (val) => {
    if (val) {
      const data = cosInvoiceListToMap.reduce((obj, data) => {
        Object.assign(obj, {
          totalAmount: obj["totalAmount"]
            ? obj["totalAmount"] + parseFloat(data.total_amount)
            : parseFloat(data.total_amount),
          totalQuantity: obj["totalQuantity"]
            ? obj["totalQuantity"] + parseFloat(data.quantity)
            : parseFloat(data.quantity),
        });
        return obj;
      }, {});
      setAmount(data?.totalAmount || 0);
      setQuantity(data?.quantity || 0);
      setCheckboxes(cosInvoiceListToMap.map((t) => t.id));
    } else {
      setCheckboxes([]);
      setAmount(0);
      setQuantity(0);
    }
  };

  useEffect(() => {
    if (
      cosInvoiceListToMap &&
      checkboxes &&
      checkboxes.length === cosInvoiceListToMap.length &&
      cosInvoiceListToMap.length !== 0
    ) {
      setAllSelected(true);
    } else {
      setAllSelected(false);
    }
  }, [checkboxes]);

  useEffect(() => {
    getClientsRequest();
    supportCoordinatorsRequest();
    getCosInvoiceMode();
    return () => emptyTableData();
  }, [getClientsRequest, supportCoordinatorsRequest, getCosInvoiceMode, emptyTableData]);

  useEffect(() => {
    if (!cosInvoiceLoading && renderLoading !== LOADER_STATUS.NA) {
      setRenderLoading(LOADER_STATUS.COMPLATE);
    }
  }, [cosInvoiceLoading]);

  useEffect(() => {
    setRenderLoading(LOADER_STATUS.PENDING);
    setCheckboxes([]);
    getCosInvoice({
      pt_id: selectedClient ? selectedClient.value : "all",
      from_date: fromDate ? fromDate : "all",
      to_date: toDate ? toDate : "all",
      delivered_date_from: deliveredFromDate ? deliveredFromDate : "all",
      delivered_date_to: deliveredToDate ? deliveredToDate : "all",
      cos_id: supportCoordiantion ? supportCoordiantion.value : "all",
    });
    setAmount(0);
  }, [supportCoordiantion, fromDate, toDate, deliveredFromDate, deliveredToDate, selectedClient]);

  const handleOnCreateClaimList = () => {
    if (isUserGracePeriodOver) return;
    if (checkboxes && checkboxes.length > 0) {
      setIsModelOpen(true);
    }
  };

  useEffect(() => {
    if (reportType) {
      getCosInvoice({
        report: reportType,
        pt_id: selectedClient ? selectedClient.value : "all",
        from_date: fromDate ? fromDate : "all",
        to_date: toDate ? toDate : "all",
        delivered_date_from: deliveredFromDate ? deliveredFromDate : "all",
        delivered_date_to: deliveredToDate ? deliveredToDate : "all",
        cos_id: supportCoordiantion ? supportCoordiantion.value : "all",
      });

      setReportType(null);
    }
  }, [reportType]);

  useEffect(() => {
    if (clientsList && clientsList) {
      clientsList.unshift({ label: "All", value: "all" });
    }
  }, [clientsList]);

  useEffect(() => {
    if (supportCoordinator && supportCoordinator) {
      supportCoordinator.unshift({ label: "All", value: "all" });
    }
  }, [supportCoordinator]);

  console.log({ amount });

  return (
    <>
      <div className='min-h-full'>
        <SideBar />
        <div
          className={`${sideBarPadding
            ? "lg:pl-[4rem] duration-300"
            : "lg:pl-64 duration-300"
            }  flex flex-col`}
        >
          <main className='h-screen flex-1 bg-white'>
            <Header
              title='Create Allied Health Invoices'
              breadcrumb={
                <Breadcrumb
                  pages={AH_BREADCRUMB(
                    AH_BREADCRUMB_PAGES.CREATE_AH_INVOICE
                  )}
                />
              }
            />
            <div className='w-full py-3 bg-white'>
              <div className='flex my-3 justify-between sm:px-6 lg:px-8 items-center bg-white w-full py-2 sticky top-[80px] z-[8]'>
                <div className='flex flex-wrap gap-x-2 gap-y-2 w-[85%]'>
                  <div className='col-span-1 w-[20%] min-w-[10rem]'>
                    <label className='block  text-sm font-medium text-gray-700 text-start'>
                      {participantLabel}
                    </label>
                    <SelectOption
                      isClearable={true}
                      isDisabled={clientsListLoader || cosInvoiceLoading}
                      cssClass=''
                      name='client'
                      isSearch={true}
                      data={clientsList && clientsList}
                      selectedOption={selectedClient}
                      handleChange={(e) => {
                        setSelectedClient(e);
                      }}
                    // placeHolder="Participant Name"
                    />
                  </div>
                  <div className='col-span-1 w-[20%] min-w-[10rem]'>
                    <label className='block  text-sm font-medium text-gray-700 text-start'>
                      Allied Health
                    </label>
                    <SelectOption
                      isClearable={true}
                      isDisabled={clientsListLoader || cosInvoiceLoading}
                      cssClass=''
                      name='sp_cos_id'
                      isSearch={true}
                      data={supportCoordinator && supportCoordinator}
                      selectedOption={supportCoordiantion}
                      handleChange={(e) => {
                        setSupportCoordination(e);
                      }}
                    // placeHolder="support Coordination"
                    />
                  </div>
                  <div className='w-[22%] min-w-[12rem]'>
                    <label className='block  text-sm font-medium text-gray-700 text-start'>
                      Created Date
                    </label>
                    <DateRangePickerNew
                      isDisabled={clientsListLoader}
                      handleCancel={() => {
                        setFromDate(null);
                        setToDate(null);
                      }}
                      handleChange={(obj) => {
                        if (obj && obj.fromDate && obj.toDate) {
                          setFromDate(obj.fromDate);
                          setToDate(obj.toDate);
                        }
                      }}
                      fromDate={fromDate}
                      toDate={toDate}
                    />
                  </div>
                  <div className='w-[22%] min-w-[12rem]'>
                    <label className='block  text-sm font-medium text-gray-700 text-start'>
                      Delivered Date
                    </label>
                    <DateRangePickerNew
                      isDisabled={clientsListLoader}
                      handleCancel={() => {
                        setDeliveredFromDate(null);
                        setDeliveredToDate(null);
                      }}
                      handleChange={(obj) => {
                        if (obj && obj.fromDate && obj.toDate) {
                          setDeliveredFromDate(obj.fromDate);
                          setDeliveredToDate(obj.toDate);
                        }
                      }}
                      fromDate={deliveredFromDate}
                      toDate={deliveredToDate}
                    />
                  </div>
                </div>
                {/* <div className="w-56 inline-flex flex-col">
                  <label className="text-start text-white text-sm font-medium text-gray-700 text-start">
                    nbsp;
                  </label>
                  <SelectBox setReportType={setReportType} />
                </div> */}
                <CustomButton
                  clickHandler={handleOnCreateClaimList}
                  Icon={<BiPlus />}
                  label='Create Allied Health Invoice'
                  isDisabled={
                    (checkboxes.length === 0 ? true : false) ||
                    isUserGracePeriodOver
                  }
                />
                {/* <Search setSearch={setSearch} search={search} /> */}
              </div>
              <div className='min-w-0'>
                <div className='flex flex-col'>
                  <div className='-my-2 min-w-0'>
                    <div className='min-w-full py-2 align-middle'>
                      <div className='border md:rounded-lg overflow-x-auto max-w-full'>
                        <table className='w-full table-fixed divide-y divide-gray-300'>
                          <thead className='bg-blue-50 sticky capitalize'>
                            <tr>
                              <th
                                scope='col'
                                className='w-[3%] px-0.5 py-3 text-center text-sm font-semibold text-gray-900 bg-blue-50'
                              >
                                <CheckBox
                                  isDisabled={isUserGracePeriodOver}
                                  checked={allSelected}
                                  handleChange={(e) => {
                                    if (
                                      cosInvoiceListToMap &&
                                      cosInvoiceListToMap.length > 0
                                    ) {
                                      setAllSelected(e);
                                      toggleCheckboxes(e);
                                    }
                                  }}
                                />
                              </th>
                              <TableHeader
                                isSort={false}
                                label={"Reference"}
                                innerCssClass='truncate'
                                cssClass='w-[6%] min-w-0 px-2 py-3 text-left text-sm font-semibold text-gray-900'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Created By"}
                                innerCssClass='truncate'
                                cssClass='w-[6%] min-w-0 px-2 py-3 text-left text-sm font-semibold text-gray-900'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Created Date"}
                                innerCssClass='whitespace-normal break-words leading-tight'
                                cssClass='w-[6%] min-w-[4.5rem] px-2 py-3 text-left text-sm font-semibold text-gray-900 align-top'
                              />
                              {isNewMode && (
                                <TableHeader
                                  isSort={false}
                                  label={participantLabel}
                                  innerCssClass='truncate'
                                  cssClass='w-[10%] min-w-0 px-2 py-3 text-left text-sm font-semibold text-gray-900'
                                />
                              )}
                              <TableHeader
                                isSort={false}
                                label={"Mgmt Style"}
                                innerCssClass='truncate'
                                cssClass='w-[8%] min-w-0 px-2 py-3 text-left text-sm font-semibold text-gray-900'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Support Item"}
                                innerCssClass='truncate'
                                cssClass='w-[11%] min-w-0 px-2 py-3 text-left text-sm font-semibold text-gray-900'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Support Item Number"}
                                innerCssClass='truncate'
                                cssClass='w-[7%] min-w-0 px-2 py-3 text-left text-sm font-semibold text-gray-900'
                              />
                              {/* <TableHeader
                                isSort={false}
                                sortName="management_style"
                                //   flipSort={flipSort}
                                //   sortBy={sortBy}
                                //   sortDescending={sortDescending}
                                label={"COS"}
                              /> */}
                              {/* <TableHeader
                                isSort={false}
                                sortName="date_delivered"
                                //   flipSort={flipSort}
                                //   sortBy={sortBy}
                                //   sortDescending={sortDescending}
                                label={"NDIS Number"}
                              /> */}
                              <TableHeader
                                isSort={false}
                                label={"Status"}
                                innerCssClass='truncate'
                                cssClass='w-[6%] min-w-0 px-2 py-3 text-left text-sm font-semibold text-gray-900'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Date Delivered"}
                                innerCssClass='truncate'
                                cssClass='w-[12%] min-w-0 px-2 py-3 text-left text-sm font-semibold text-gray-900'
                              />
                              {/* <TableHeader
                                isSort={false}
                                sortName="total_amount"
                                //   flipSort={flipSort}
                                //   sortBy={sortBy}
                                //   sortDescending={sortDescending}
                                label={"GST Code"}
                              /> */}
                              <TableHeader
                                isSort={false}
                                label={"Km"}
                                innerCssClass='truncate'
                                cssClass='w-[4%] min-w-0 px-2 py-3 text-right text-sm font-semibold text-gray-900'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Hours"}
                                innerCssClass='truncate'
                                cssClass='w-[5%] min-w-0 px-2 py-3 text-right text-sm font-semibold text-gray-900'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Rate"}
                                innerCssClass='truncate'
                                cssClass='w-[5%] min-w-0 px-2 py-3 text-right text-sm font-semibold text-gray-900'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Total value"}
                                innerCssClass='truncate'
                                cssClass='w-[8%] min-w-0 px-2 py-3 text-right text-sm font-semibold text-gray-900'
                              />
                              <th className='w-[3%] px-1 py-3 bg-blue-50'>
                                <div className='sr-only'>View</div>
                              </th>
                            </tr>
                          </thead>
                          <tbody className='divide-y divide-gray-200 bg-white'>
                            {(renderLoading === LOADER_STATUS.PENDING &&
                              cosInvoiceLoading) ||
                              createCosInvoiceLoading ? (
                              <tr>
                                <td
                                  colSpan={isNewMode ? 12 : 13}
                                  className='bg-gray-50 py-2'
                                >
                                  <CircularLoader
                                    classes='flex justify-center items-center'
                                    classloader='loader-l'
                                  />
                                </td>
                              </tr>
                            ) : cosInvoiceListToMap &&
                              cosInvoiceListToMap.length > 0 ? (
                              cosInvoiceListToMap.map((item, index) => (
                                <COSInvoiceTabel
                                  isUserGracePeriodOver={isUserGracePeriodOver}
                                  isNewMode={isNewMode}
                                  checkboxes={checkboxes}
                                  handleCheckboxChange={(e) =>
                                    handleCheckboxChange(e, item.id, item)
                                  }
                                  item={item}
                                  key={index}
                                />
                              ))
                            ) : (
                              renderLoading !== LOADER_STATUS.NA &&
                              cosInvoiceListToMap.length === 0 && (
                                <tr>
                                  <td
                                    colSpan={isNewMode ? 12 : 13}
                                    className='py-6 text-center text-red-600'
                                  >
                                    No Data Found !
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      {isOpenModel && isUserGracePeriodOver === false && (
        <COSNewModal
          createCosInvoices={createCosInvoices}
          checkboxes={checkboxes}
          amount={amount}
          openModel={isOpenModel}
          handleClose={setIsModelOpen}
          cosInvoiceMode={cosInvoiceMode}
        />
      )}
    </>
  );
};

export default COSInvoicePage;
